// SAVE LOCAL STORAGE
export function SaveLocalStorage(name, data) {
    localStorage.setItem(name, data);
  }